// 数据中心 我的数据模块
export default [
  // 首页
  {
    path: "DataAnalysis",
    name: "DataAnalysis",
    component: () => import("@/views/dataAnalysis/index.vue"),
  },
];
